import React from "react";
import { useNavigate } from "react-router-dom";
import ButtonWithSound from "../ButtonWithSound/ButtonWithSound";

const HelpPage = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/");
  };

  return (
    <div className="bg-gradient-to-b h-screen overflow-y-scroll from-green-400 to-green-600 min-h-screen p-6">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl font-bold text-white text-center mb-8">
          🍇 Guide 🍇
        </h1>

        <div className="bg-white rounded-lg shadow-lg mb-6 overflow-hidden">
          <div className="bg-yellow-400 text-2xl font-semibold p-4">
            <div className="flex items-center">
              <span className="mr-2">🍏</span>Delicious Fruits
            </div>
          </div>
          <div className="bg-yellow-100 p-4">
            <p className="mb-4">Collect these juicy fruits for points:</p>
            <div className="flex justify-around text-4xl mb-4">
              <span>🍎</span>
              <span>🍌</span>
              <span>🍇</span>
              <span>🍊</span>
              <span>🍓</span>
              <span>🍑</span>
            </div>
            <p className="text-center font-semibold">
              Each fruit gives you 10 points!
            </p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg mb-6 overflow-hidden">
          <div className="bg-red-500 text-white text-2xl font-semibold p-4">
            <div className="flex items-center">
              <span className="mr-2">☠️</span>Dangerous Obstacles
            </div>
          </div>
          <div className="bg-red-100 p-4">
            <p className="mb-4">Watch out for these menacing enemies:</p>
            <div className="flex justify-around text-4xl mb-4">
              <span>🐍</span>
              <span>🐝</span>
            </div>
            <p className="text-center font-semibold">
              Hitting them means Game Over!
            </p>
            <p className="text-center mt-2">
              Losing more than three fruits also ends the game.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg mb-6 overflow-hidden">
          <div className="bg-purple-500 text-white text-2xl font-semibold p-4">
            <div className="flex items-center">
              <span className="mr-2">⭐</span>Super Star Power
            </div>
          </div>
          <div className="bg-purple-100 p-4">
            <p className="mb-4">
              Grab the magical star for an incredible boost:
            </p>
            <div className="text-center text-6xl mb-4">⭐</div>
            <p className="text-center font-semibold">
              Gain a 50-point boost while the power-up is active!
            </p>
          </div>
        </div>

        <p className="text-xl text-white text-center font-semibold mb-6">
          Enjoy the juicy hunt and remember: Stay fruity, stay fun! 🍉🍍
        </p>

        <div className="flex justify-center">
          <ButtonWithSound
            onClick={goToHome}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full text-lg flex items-center"
          >
            <span className="mr-2">🏠</span> Back to Home
          </ButtonWithSound>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
